import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiPlus, FiPackage, FiBox, FiTool, FiUploadCloud, FiSave, FiX, FiArrowLeft } from "react-icons/fi";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { useDropzone } from "react-dropzone";
import { baseurl, imgurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";

const GST_SLABS = [0, 5, 12, 18, 28];
const UNIT_OPTIONS = ["Pcs", "Kgs", "Mtrs", "Hrs", "Ltrs", "Nos", "Sq.Ft"];

const DEFAULT_PRODUCT = {
  type: "Product", name: "", hsn: "", unit: "Pcs", rate: "", tax: "18",
  description: "", imageFile: null, imagePreview: "", minOrderQty: "",
  stockQty: "0", inventoryTracked: "false",
};

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --ep-teal:      #0a5556;
  --ep-teal-mid:  #0c7172;
  --ep-teal-lite: #14b8a6;
  --ep-gold:      #FFD166;
  --ep-bg:        #eef6f6;
  --ep-white:     #ffffff;
  --ep-border:    rgba(10,85,86,0.12);
  --ep-text:      #0f2a2a;
  --ep-muted:     #5a8080;
  --ep-danger:    #ef4444;
  --ep-success:   #10b981;
}

@keyframes ep__fadeUp  { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
@keyframes ep__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
@keyframes ep__spin    { to{transform:rotate(360deg)} }

.ep__wrap {
  font-family:'DM Sans',sans-serif;
  padding:26px 26px 80px;
  background:var(--ep-bg);
  min-height:100vh;
  animation:ep__fadeUp 0.4s ease both;
}

/* header */
.ep__hd { display:flex; align-items:center; gap:14px; margin-bottom:26px; flex-wrap:wrap; }
.ep__hd-icon {
  width:50px; height:50px; border-radius:15px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ep-teal),var(--ep-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:22px; color:#fff; box-shadow:0 6px 20px rgba(10,85,86,0.28);
}
.ep__hd-title { font-family:'Sora',sans-serif; font-size:21px; font-weight:800; color:var(--ep-text); letter-spacing:-0.03em; margin:0 0 3px; }
.ep__hd-sub   { font-size:12.5px; color:var(--ep-muted); margin:0; }
.ep__hd-uuid  { font-size:11px; font-family:'Sora',sans-serif; color:var(--ep-teal-lite); letter-spacing:0.04em; background:rgba(10,85,86,0.07); padding:2px 8px; border-radius:6px; display:inline-block; margin-top:3px; }

/* layout */
.ep__layout { display:grid; grid-template-columns:1fr 300px; gap:18px; align-items:start; }
@media(max-width:900px){ .ep__layout{ grid-template-columns:1fr; } }

/* card */
.ep__card {
  background:var(--ep-white); border-radius:20px;
  border:1px solid var(--ep-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  overflow:hidden; position:relative;
}
.ep__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--ep-teal) 0%,var(--ep-teal-lite) 55%,var(--ep-gold) 100%);
}
.ep__card-hd {
  display:flex; align-items:center; gap:10px;
  padding:16px 22px; border-bottom:1px solid var(--ep-border);
}
.ep__card-hd-icon {
  width:32px; height:32px; border-radius:9px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ep-teal),var(--ep-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:14px; color:#fff; box-shadow:0 3px 10px rgba(10,85,86,0.22);
}
.ep__card-hd-title { font-family:'Sora',sans-serif; font-size:13px; font-weight:800; color:var(--ep-text); }
.ep__card-body { padding:22px; }

/* type toggle */
.ep__type-row { display:flex; gap:10px; }
.ep__type-btn {
  flex:1; display:flex; align-items:center; justify-content:center; gap:8px;
  padding:11px 16px; border-radius:12px; cursor:default; font-size:13px;
  font-family:'Sora',sans-serif; font-weight:700;
  border:2px solid var(--ep-border); background:rgba(10,85,86,0.03); color:var(--ep-muted);
}
.ep__type-btn--active {
  border-color:var(--ep-teal); background:rgba(10,85,86,0.08); color:var(--ep-teal);
  box-shadow:0 3px 12px rgba(10,85,86,0.14);
}

/* field */
.ep__grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
.ep__grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
.ep__grid-4 { display:grid; grid-template-columns:1fr 1fr 1fr 1fr; gap:14px; }
@media(max-width:700px){ .ep__grid-2,.ep__grid-3,.ep__grid-4{ grid-template-columns:1fr 1fr; } }
@media(max-width:480px){ .ep__grid-2,.ep__grid-3,.ep__grid-4{ grid-template-columns:1fr; } }
.ep__full { grid-column:1/-1; }

.ep__field { display:flex; flex-direction:column; gap:5px; }
.ep__label {
  font-family:'Sora',sans-serif; font-size:10.5px; font-weight:700;
  letter-spacing:0.07em; text-transform:uppercase; color:var(--ep-teal);
}
.ep__req { color:var(--ep-danger); }
.ep__input, .ep__select, .ep__textarea {
  padding:9px 13px; font-size:13.5px; font-family:'DM Sans',sans-serif;
  color:var(--ep-text); background:#f3fafa;
  border:1.5px solid rgba(10,85,86,0.14); border-radius:10px;
  outline:none; transition:border-color 0.18s, box-shadow 0.18s, background 0.18s; width:100%;
}
.ep__input:focus, .ep__select:focus, .ep__textarea:focus {
  border-color:var(--ep-teal); box-shadow:0 0 0 3.5px rgba(10,85,86,0.1); background:#fff;
}
.ep__input::placeholder, .ep__textarea::placeholder { color:#9ababa; }
.ep__select {
  appearance:none; cursor:pointer;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 11px center; padding-right:32px;
  background-color:#f3fafa;
}
.ep__select:focus { background-color:#fff; }
.ep__textarea { resize:vertical; min-height:90px; }

.ep__amount-wrap { position:relative; }
.ep__amount-icon {
  position:absolute; left:12px; top:50%; transform:translateY(-50%);
  color:var(--ep-muted); font-size:13px; pointer-events:none; display:flex; align-items:center;
}
.ep__amount-wrap .ep__input { padding-left:30px; }

/* toggle switch */
.ep__toggle-row { display:flex; align-items:center; gap:12px; margin-top:4px; }
.ep__toggle-switch { position:relative; width:42px; height:22px; flex-shrink:0; cursor:pointer; }
.ep__toggle-switch input { opacity:0; width:0; height:0; position:absolute; }
.ep__toggle-track { position:absolute; inset:0; border-radius:50px; background:#d4e8e8; transition:background 0.22s; }
.ep__toggle-thumb {
  position:absolute; top:3px; left:3px; width:16px; height:16px;
  border-radius:50%; background:#fff; box-shadow:0 2px 6px rgba(0,0,0,0.18); transition:transform 0.22s;
}
.ep__toggle-switch input:checked ~ .ep__toggle-track { background:var(--ep-teal); }
.ep__toggle-switch input:checked ~ .ep__toggle-thumb { transform:translateX(20px); }
.ep__toggle-label { font-size:13px; color:var(--ep-text); font-weight:500; }

/* dropzone */
.ep__dropzone {
  border:2px dashed rgba(10,85,86,0.25); border-radius:14px; padding:20px 16px;
  text-align:center; cursor:pointer; background:#f7fdfd;
  transition:border-color 0.18s, background 0.18s;
}
.ep__dropzone:hover, .ep__dropzone--active { border-color:var(--ep-teal); background:rgba(10,85,86,0.04); }
.ep__dropzone-icon { font-size:26px; color:var(--ep-teal-lite); margin-bottom:6px; }
.ep__dropzone-text { font-size:12.5px; color:var(--ep-muted); line-height:1.5; }
.ep__dropzone-text strong { color:var(--ep-teal); }

/* image */
.ep__img-wrap { display:flex; flex-direction:column; align-items:center; gap:10px; margin-bottom:12px; }
.ep__img-preview {
  width:90px; height:90px; object-fit:cover;
  border-radius:14px; border:2px solid var(--ep-border);
  box-shadow:0 4px 14px rgba(10,85,86,0.12);
}
.ep__img-badge {
  font-size:10.5px; font-family:'Sora',sans-serif; font-weight:700;
  background:rgba(10,85,86,0.07); color:var(--ep-teal); border-radius:6px; padding:2px 8px;
}

/* summary */
.ep__summary-row {
  display:flex; justify-content:space-between; align-items:center;
  padding:8px 0; border-bottom:1px solid var(--ep-border);
}
.ep__summary-row:last-child { border-bottom:none; }
.ep__summary-lbl { font-size:12px; color:var(--ep-muted); }
.ep__summary-val { font-family:'Sora',sans-serif; font-size:13px; font-weight:700; color:var(--ep-text); }
.ep__summary-val--teal { color:var(--ep-teal); font-size:16px; }
.ep__type-chip {
  display:inline-flex; align-items:center; gap:5px;
  font-size:11px; font-weight:700; font-family:'Sora',sans-serif;
  border-radius:50px; padding:3px 10px;
}
.ep__type-chip--product { background:rgba(10,85,86,0.09); color:var(--ep-teal); border:1px solid rgba(10,85,86,0.18); }
.ep__type-chip--service  { background:rgba(59,130,246,0.09); color:#2563eb; border:1px solid rgba(59,130,246,0.20); }

/* submit */
.ep__submit {
  width:100%; padding:13px; border-radius:12px; border:none; cursor:pointer;
  font-size:14px; font-family:'Sora',sans-serif; font-weight:800; color:#fff;
  background:linear-gradient(135deg,var(--ep-teal),var(--ep-teal-lite));
  box-shadow:0 4px 18px rgba(10,85,86,0.30);
  display:flex; align-items:center; justify-content:center; gap:8px;
  transition:transform 0.14s, box-shadow 0.18s, opacity 0.18s;
}
.ep__submit:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 8px 26px rgba(10,85,86,0.36); }
.ep__submit:disabled { opacity:.55; cursor:not-allowed; }
.ep__spinner { width:18px; height:18px; border-radius:50%; border:2.5px solid rgba(255,255,255,0.3); border-top-color:#fff; animation:ep__spin 0.75s linear infinite; }

/* skeleton */
.ep__skel {
  border-radius:8px;
  background:linear-gradient(90deg,#e8f4f4 0%,#d0eded 50%,#e8f4f4 100%);
  background-size:600px 100%; animation:ep__shimmer 1.4s linear infinite;
}
.ep__skel-img { width:90px; height:90px; border-radius:14px; }
`;

/* ─── Skeleton ─── */
const FormSkeleton = () => (
  <div style={{ display:"grid", gridTemplateColumns:"1fr 300px", gap:18, alignItems:"start" }}>
    <div style={{ display:"flex", flexDirection:"column", gap:18 }}>
      {[1,2,3].map(i => (
        <div key={i} style={{ background:"#fff", borderRadius:20, border:"1px solid rgba(10,85,86,0.10)", overflow:"hidden", position:"relative" }}>
          <div style={{ height:3, background:"linear-gradient(90deg,#0a5556,#14b8a6,#FFD166)" }} />
          <div style={{ padding:22, display:"flex", flexDirection:"column", gap:14 }}>
            <div className="ep__skel" style={{ width:120, height:13 }} />
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14 }}>
              {[1,2,3].map(j => (
                <div key={j}>
                  <div className="ep__skel" style={{ width:60, height:10, marginBottom:8 }} />
                  <div className="ep__skel" style={{ height:38, borderRadius:10 }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
    <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
      <div style={{ background:"#fff", borderRadius:20, border:"1px solid rgba(10,85,86,0.10)", overflow:"hidden" }}>
        <div style={{ height:3, background:"linear-gradient(90deg,#0a5556,#14b8a6,#FFD166)" }} />
        <div style={{ padding:22, display:"flex", flexDirection:"column", gap:12 }}>
          <div className="ep__skel ep__skel-img" style={{ margin:"0 auto" }} />
          {[1,2,3,4].map(k => (
            <div key={k} style={{ display:"flex", justifyContent:"space-between" }}>
              <div className="ep__skel" style={{ width:70, height:12 }} />
              <div className="ep__skel" style={{ width:80, height:12 }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ background:"#fff", borderRadius:20, border:"1px solid rgba(10,85,86,0.10)", overflow:"hidden" }}>
        <div style={{ height:3, background:"linear-gradient(90deg,#0a5556,#14b8a6,#FFD166)" }} />
        <div style={{ padding:22 }}>
          <div className="ep__skel" style={{ height:46, borderRadius:12 }} />
        </div>
      </div>
    </div>
  </div>
);

function EditProduct() {
  const { uuid } = useParams();
  const [newProduct, setNewProduct] = useState({ ...DEFAULT_PRODUCT });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading]     = useState(true);
  const token = localStorage.getItem("auth_token");

  /* ── fetch (unchanged) ── */
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${baseurl}getProductByUuid/${uuid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          const item = response.data.data;
          const details = item.product_data;
          setNewProduct({
            type: item.type,
            name: details.name || "",
            hsn: details.hsn_sac || "",
            unit: details.unit || "Pcs",
            rate: details.rate || "",
            tax: details.tax_percent?.toString() || "18",
            description: details.description || "",
            minOrderQty: details.min_order_qty || "1",
            stockQty: item.current_stock || "0",
            inventoryTracked: details.inventory_tracked ? "true" : "false",
            imagePreview: details.image_path ? `${imgurl}${details.image_path}` : "",
            imageFile: null,
          });
        }
      } catch (error) {
        console.error("FETCH ERROR:", error);
        Swal.fire("Error", "Could not fetch product details", "error");
      } finally {
        setTimeout(() => setIsLoading(false), 500);
      }
    };
    if (uuid) fetchProduct();
  }, [uuid, token]);

  const updateProductField = (field, value) => setNewProduct(prev => ({ ...prev, [field]: value }));

  /* ── Toast (unchanged) ── */
  const Toast = Swal.mixin({
    toast: true, position:"top-end", showConfirmButton:false,
    timer:3000, timerProgressBar:true,
    customClass: { popup:'colored-toast', title:'toast-title-custom', timerProgressBar:'toast-progress-custom' },
    didOpen: (toast) => { toast.onmouseenter = Swal.stopTimer; toast.onmouseleave = Swal.resumeTimer; }
  });

  /* ── handleUpdateProduct (unchanged) ── */
  const handleUpdateProduct = async (e) => {
    e.preventDefault();
    if (!newProduct.name.trim() || !newProduct.rate)
      return Toast.fire({ icon:"warning", title:"Name and Rate are required" });
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("type", newProduct.type);
    formData.append("name", newProduct.name);
    formData.append("hsn", newProduct.hsn);
    formData.append("unit", newProduct.unit);
    formData.append("rate", newProduct.rate);
    formData.append("tax", newProduct.tax);
    formData.append("description", newProduct.description);
    formData.append("minOrderQty", newProduct.minOrderQty);
    formData.append("stockQty", newProduct.stockQty);
    formData.append("inventoryTracked", newProduct.inventoryTracked);
    if (newProduct.imageFile) formData.append("image", newProduct.imageFile);
    try {
      const response = await axios.put(`${baseurl}updateProduct/${uuid}`, formData, {
        headers: { "Content-Type":"multipart/form-data", Authorization:`Bearer ${token}` },
      });
      if (response.data.success) Toast.fire({ icon:"success", title:"Product updated successfully" });
      else Toast.fire({ icon:"error", title: response.data.message || "Failed to update" });
    } catch (error) {
      Toast.fire({ icon:"error", title: error.response?.data?.message || "Server error occurred" });
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ── Dropzone (logic unchanged) ── */
  const DropzoneArea = () => {
    const onDrop = (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;
      const file = acceptedFiles[0];
      const previewUrl = URL.createObjectURL(file);
      updateProductField("imageFile", file);
      updateProductField("imagePreview", previewUrl);
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      accept:{ "image/*":[] }, multiple:false, maxSize:4*1024*1024, onDrop,
    });
    return (
      <div {...getRootProps()} className={`ep__dropzone ${isDragActive ? "ep__dropzone--active" : ""}`}>
        <input {...getInputProps()} />
        <div className="ep__dropzone-icon"><FiUploadCloud /></div>
        <div className="ep__dropzone-text">
          {isDragActive ? <strong>Drop to replace…</strong> : <><strong>Click or drag</strong> to update image</>}
        </div>
      </div>
    );
  };

  /* derived */
  const rateVal   = parseFloat(newProduct.rate) || 0;
  const taxVal    = parseFloat(newProduct.tax) || 0;
  const taxAmt    = (rateVal * taxVal) / 100;
  const totalRate = rateVal + taxAmt;

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper">
        <div className="ep__wrap">

          {/* Header */}
          <div className="ep__hd">
            <div className="ep__hd-icon"><FiPackage /></div>
            <div>
              <div className="ep__hd-title">Update {newProduct.type}</div>
              <div className="ep__hd-sub">Modify specifications for your item</div>
              <div className="ep__hd-uuid">{uuid}</div>
            </div>
          </div>

          {isLoading ? <FormSkeleton /> : (
            <form onSubmit={handleUpdateProduct}>
              <div className="ep__layout">

                {/* ── LEFT ── */}
                <div style={{ display:"flex", flexDirection:"column", gap:18 }}>

                  {/* Type (read-only display) */}
                  <div className="ep__card">
                    <div className="ep__card-hd">
                      <div className="ep__card-hd-icon"><FiBox size={13} /></div>
                      <div className="ep__card-hd-title">Item Type</div>
                    </div>
                    <div className="ep__card-body">
                      <div className="ep__type-row">
                        {["Product","Service"].map(t => (
                          <div key={t} className={`ep__type-btn ${newProduct.type === t ? "ep__type-btn--active" : ""}`}>
                            {t === "Product" ? <FiBox size={14} /> : <FiTool size={14} />}
                            {t === "Product" ? "Product (Goods)" : "Service (SAC)"}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Core Details */}
                  <div className="ep__card">
                    <div className="ep__card-hd">
                      <div className="ep__card-hd-icon"><FiPackage size={13} /></div>
                      <div className="ep__card-hd-title">Core Details</div>
                    </div>
                    <div className="ep__card-body" style={{ display:"flex", flexDirection:"column", gap:14 }}>

                      <div className="ep__field ep__full">
                        <label className="ep__label">Name <span className="ep__req">*</span></label>
                        <input type="text" className="ep__input"
                          value={newProduct.name}
                          onChange={(e) => updateProductField("name", e.target.value)} />
                      </div>

                      <div className="ep__grid-3">
                        <div className="ep__field">
                          <label className="ep__label">HSN / SAC</label>
                          <input type="text" className="ep__input"
                            value={newProduct.hsn}
                            onChange={(e) => updateProductField("hsn", e.target.value)} />
                        </div>
                        <div className="ep__field">
                          <label className="ep__label">Unit</label>
                          <select className="ep__select" value={newProduct.unit}
                            onChange={(e) => updateProductField("unit", e.target.value)}>
                            {UNIT_OPTIONS.map(u => <option key={u} value={u}>{u}</option>)}
                          </select>
                        </div>
                        <div className="ep__field">
                          <label className="ep__label">GST Tax %</label>
                          <select className="ep__select" value={newProduct.tax}
                            onChange={(e) => updateProductField("tax", e.target.value)}>
                            {GST_SLABS.map(g => <option key={g} value={g}>{g}%</option>)}
                          </select>
                        </div>
                      </div>

                      <div className="ep__grid-2">
                        <div className="ep__field">
                          <label className="ep__label">Standard Rate <span className="ep__req">*</span></label>
                          <div className="ep__amount-wrap">
                            <span className="ep__amount-icon"><FaIndianRupeeSign size={12} /></span>
                            <input type="number" step="0.01" min="0" placeholder="0.00"
                              className="ep__input"
                              value={newProduct.rate}
                              onChange={(e) => updateProductField("rate", e.target.value)} />
                          </div>
                        </div>

                        {newProduct.type === "Product" && (
                          <div className="ep__field">
                            <label className="ep__label">Current Stock</label>
                            <input type="number" min="0" className="ep__input"
                              value={newProduct.stockQty}
                              onChange={(e) => updateProductField("stockQty", e.target.value)} />
                          </div>
                        )}
                      </div>

                      {newProduct.type === "Product" && (
                        <div className="ep__grid-2">
                          <div className="ep__field">
                            <label className="ep__label">Min. Order Qty</label>
                            <input type="number" min="1" className="ep__input"
                              value={newProduct.minOrderQty}
                              onChange={(e) => updateProductField("minOrderQty", e.target.value)} />
                          </div>
                          <div className="ep__field">
                            <label className="ep__label">Track Inventory</label>
                            <div className="ep__toggle-row">
                              <label className="ep__toggle-switch">
                                <input type="checkbox"
                                  checked={newProduct.inventoryTracked === "true"}
                                  onChange={(e) => updateProductField("inventoryTracked", e.target.checked ? "true" : "false")} />
                                <div className="ep__toggle-track" />
                                <div className="ep__toggle-thumb" />
                              </label>
                              <span className="ep__toggle-label">
                                {newProduct.inventoryTracked === "true" ? "Enabled" : "Disabled"}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>

                  {/* Description + Image */}
                  <div className="ep__card">
                    <div className="ep__card-hd">
                      <div className="ep__card-hd-icon"><FiUploadCloud size={13} /></div>
                      <div className="ep__card-hd-title">Description &amp; Image</div>
                    </div>
                    <div className="ep__card-body" style={{ display:"grid", gridTemplateColumns:"1fr 200px", gap:18 }}>
                      <div className="ep__field">
                        <label className="ep__label">Description</label>
                        <textarea className="ep__textarea" rows="4"
                          value={newProduct.description}
                          onChange={(e) => updateProductField("description", e.target.value)}
                          placeholder="Detailed notes used for printing on invoices." />
                      </div>
                      <div className="ep__field">
                        <label className="ep__label">Image</label>
                        {newProduct.imagePreview && (
                          <div className="ep__img-wrap">
                            <img src={newProduct.imagePreview} alt="Preview" className="ep__img-preview" />
                            {newProduct.imageFile && (
                              <span className="ep__img-badge">New image selected</span>
                            )}
                          </div>
                        )}
                        <DropzoneArea />
                      </div>
                    </div>
                  </div>

                </div>

                {/* ── RIGHT ── */}
                <div style={{ display:"flex", flexDirection:"column", gap:14 }}>

                  {/* Summary */}
                  <div className="ep__card">
                    <div className="ep__card-hd">
                      <div className="ep__card-hd-icon" style={{ background:"linear-gradient(135deg,#b45309,var(--ep-gold))" }}>
                        <FaIndianRupeeSign size={13} />
                      </div>
                      <div className="ep__card-hd-title">Item Summary</div>
                    </div>
                    <div className="ep__card-body">
                      <div className="ep__summary-row">
                        <span className="ep__summary-lbl">Type</span>
                        <span className={`ep__type-chip ${newProduct.type === "Product" ? "ep__type-chip--product" : "ep__type-chip--service"}`}>
                          {newProduct.type}
                        </span>
                      </div>
                      <div className="ep__summary-row">
                        <span className="ep__summary-lbl">Name</span>
                        <span className="ep__summary-val" style={{ maxWidth:150, textAlign:"right", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                          {newProduct.name || <span style={{ color:"#b0cece" }}>—</span>}
                        </span>
                      </div>
                      <div className="ep__summary-row">
                        <span className="ep__summary-lbl">Base Rate</span>
                        <span className="ep__summary-val">
                          {rateVal > 0 ? `₹${rateVal.toLocaleString("en-IN",{minimumFractionDigits:2})}` : <span style={{color:"#b0cece"}}>—</span>}
                        </span>
                      </div>
                      <div className="ep__summary-row">
                        <span className="ep__summary-lbl">GST ({newProduct.tax}%)</span>
                        <span className="ep__summary-val">
                          {rateVal > 0 ? `₹${taxAmt.toLocaleString("en-IN",{minimumFractionDigits:2})}` : <span style={{color:"#b0cece"}}>—</span>}
                        </span>
                      </div>
                      <div className="ep__summary-row" style={{ paddingTop:12 }}>
                        <span className="ep__summary-lbl" style={{ fontWeight:700, color:"var(--ep-text)" }}>Total Rate</span>
                        <span className="ep__summary-val ep__summary-val--teal">
                          {rateVal > 0 ? `₹${totalRate.toLocaleString("en-IN",{minimumFractionDigits:2})}` : <span style={{color:"#b0cece",fontSize:13}}>—</span>}
                        </span>
                      </div>
                      {newProduct.type === "Product" && (
                        <div className="ep__summary-row">
                          <span className="ep__summary-lbl">Stock Qty</span>
                          <span className="ep__summary-val">{newProduct.stockQty || "0"}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="ep__card">
                    <div className="ep__card-body">
                      <button type="submit" className="ep__submit" disabled={isSubmitting}>
                        {isSubmitting ? <div className="ep__spinner" /> : <FiSave size={16} />}
                        {isSubmitting ? "Saving…" : "Update Master Data"}
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          )}

        </div>
      </main>
    </>
  );
}

export default EditProduct;
